document.addEventListener("DOMContentLoaded", () => {

  const modal = document.getElementById("hastaVideoModal");
  const frame = document.getElementById("hastaVideoFrame");

  if (!modal || !frame) return;

  document.querySelectorAll(".hasta-video-trigger").forEach(link => {

    link.addEventListener("click", (e) => {

      e.preventDefault();

      const videoUrl = link.dataset.video;

      frame.src = videoUrl + "?autoplay=1";

      modal.classList.add("active");

    });

  });

  function closeModal() {

    modal.classList.remove("active");

    frame.src = "";

  }

  const closeButton = document.querySelector(".hasta-video-close");
  const backdrop = document.querySelector(".hasta-video-backdrop");

  if (closeButton) {
    closeButton.addEventListener("click", closeModal);
  }

  if (backdrop) {
    backdrop.addEventListener("click", closeModal);
  }

});